const t=(t,e,r)=>n=>{if(!n)return null;const l={parentFolder:n?`${e}/`:"",type:n||e,...t};return r(l)(n)};export{t as default};
//# sourceMappingURL=get-issuer-image.js.map
